/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NumberCircle09Icon16Light } from './NumberCircle09Icon16Light';
import { NumberCircle09Icon16Regular } from './NumberCircle09Icon16Regular';
import { NumberCircle09Icon16Solid } from './NumberCircle09Icon16Solid';
import { NumberCircle09Icon20Light } from './NumberCircle09Icon20Light';
import { NumberCircle09Icon20Regular } from './NumberCircle09Icon20Regular';
import { NumberCircle09Icon20Solid } from './NumberCircle09Icon20Solid';
import { NumberCircle09Icon24Regular } from './NumberCircle09Icon24Regular';
import { NumberCircle09Icon24Solid } from './NumberCircle09Icon24Solid';
import { NumberCircle09Icon32Regular } from './NumberCircle09Icon32Regular';
import { NumberCircle09Icon64Regular } from './NumberCircle09Icon64Regular';
var sizes = {
    16: {
        light: NumberCircle09Icon16Light,
        regular: NumberCircle09Icon16Regular,
        solid: NumberCircle09Icon16Solid,
    },
    20: {
        light: NumberCircle09Icon20Light,
        regular: NumberCircle09Icon20Regular,
        solid: NumberCircle09Icon20Solid,
    },
    24: {
        regular: NumberCircle09Icon24Regular,
        solid: NumberCircle09Icon24Solid,
    },
    32: {
        regular: NumberCircle09Icon32Regular,
    },
    64: {
        regular: NumberCircle09Icon64Regular,
    },
};
export var NumberCircle09Icon = forwardRef('NumberCircle09Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
